// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/scss/app.scss
// module id = 6
// module chunks = 0